import { createSelector } from 'reselect';
import type { LocationState } from 'redux-first-router';
import { get } from 'lodash';
import {
  ROUTE_CREATE_CRITERIA,
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_DISCOVER_INVESTING_IDEAS_MARKET,
  ROUTE_DEPRECATED_PORTFOLIO_HOME,
  ROUTE_STOCKS_HOME,
  ROUTE_MY_PORTFOLIOS,
  ROUTE_DASHBOARD,
  ROUTE_WATCHLIST,
  ROUTE_NARRATIVE_COMMUNITY,
  ROUTE_STOCKS_MARKET,
  ROUTE_MARKET,
  ROUTE_USER_PROFILE,
  ROUTE_USER_NOTIFICATIONS,
  ROUTE_USER_BETA_LAB,
  ROUTE_USER_SUBSCRIPTION_AND_BILLING,
} from '@/constants/routes';

const getLocation = ({ location }: { location: LocationState }) => ({
  type: get(location, ['type'], ''),
  prevType: get(location, ['prev', 'type'], ''),
  payload: get(location, ['payload'], undefined),
  query: get(location, ['query'], undefined),
});

export const getCanGoBack = createSelector(
  [getLocation],
  ({ type, prevType, payload }) => {
    const market = get(payload, ['market'], undefined);
    const stocksHome = type === ROUTE_STOCKS_HOME && market === undefined;
    return (
      RUNTIME_ENV === 'native' &&
      prevType !== '' &&
      stocksHome === false &&
      [
        ROUTE_DASHBOARD,
        ROUTE_MY_PORTFOLIOS,
        ROUTE_WATCHLIST,
        ROUTE_NARRATIVE_COMMUNITY,
        ROUTE_DISCOVER_INVESTING_IDEAS,
        ROUTE_DISCOVER_INVESTING_IDEAS_MARKET,
        ROUTE_CREATE_CRITERIA, // Screener
        // DISCOVER SUBS
        ROUTE_STOCKS_MARKET,
        ROUTE_MARKET,
        // PROFILE
        ROUTE_USER_PROFILE,
        ROUTE_USER_NOTIFICATIONS,
        ROUTE_USER_SUBSCRIPTION_AND_BILLING,
        ROUTE_USER_BETA_LAB,
        // OLD
        ROUTE_DEPRECATED_PORTFOLIO_HOME,
      ].includes(type) === false
    );
  }
);
